<template>
  <div class="">
    <label :for="inputConfig.id">{{ inputConfig.name }}</label>
    <select :id="inputConfig.id" class="form-control"
            v-model="form[inputConfig.id]"
            :required="inputConfig.required">
      <option v-for="(option,index) in options" :value="option">{{ option }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "SelectBoxInput1",
  props: {
    inputConfig: {},
    form: {}
  },
  computed: {
    options() {
      return this.inputConfig.options
    },
  }
}
</script>

<style scoped>

</style>